import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { url } from 'src/config';
import { orgId } from 'src/constants';
import { isLoading } from './isLoading';

const initialState = {
  approveCallerId: []
};

const slice = createSlice({
  name: 'VerifyCaller',
  initialState,
  reducers: {
    approveCallerId(state, action) {
      state.approveCallerId = action.payload;
    }
  }
});

export const reducer = slice.reducer;

export const fetchApproveCaller = (data = {}) => async (dispatch) => {
  dispatch(isLoading(true));
  const current_store = window.localStorage.getItem('current_store');
  try {
    const { current_vzid } = JSON.parse(current_store);
    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);

    const response = await axios.post(`${url}approved-callerids/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseCode } = await response.data;

    if (responseCode === '00') {
      const { returnedRecords } = response.data.responseData;

      dispatch(slice.actions.approveCallerId(returnedRecords));
      dispatch(isLoading(false));
    } else {
      throw new Error();
    }
  } catch (error) {
    console.error(error);
    dispatch(isLoading(false));
    return error;
  }
};
